import React from 'react';
import { Button, Popconfirm } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

interface TaskControlsProps {
    tasksLength: number;
    hasCompleted: boolean;
    completedCount: number;
    setIsAdding: (isAdding: boolean) => void;
    onClearCompleted: () => void;
}

export const TaskControls: React.FC<TaskControlsProps> = ({
    tasksLength,
    hasCompleted,
    completedCount,
    setIsAdding,
    onClearCompleted
}) => {
    return (
        <div style={{ marginTop: tasksLength > 0 ? 8 : 0, display: 'flex', gap: 8 }}>
            <Button
                type="dashed"
                size="small"
                icon={<PlusOutlined />}
                onClick={() => setIsAdding(true)}
                style={{ flex: 1 }}
            >
                添加任务
            </Button>
            {hasCompleted && (
                <Popconfirm
                    title={`确定清空 ${completedCount} 个已完成任务?`}
                    onConfirm={onClearCompleted}
                    okText="清空"
                    cancelText="取消"
                >
                    <Button size="small" danger type="text">
                        清空已完成
                    </Button>
                </Popconfirm>
            )}
        </div>
    );
};
